import React from 'react';

// Línea de vida del trámite (stepper de etapas de ANSES).
// Recibe `etapas`: [{ nombre, completa, fecha }]. Solo la 1ra etapa suele traer fecha
// (ANSES no informa la fecha de cada transición).
const LineaDeVidaExpediente = ({ etapas = [] }) => {
    if (!etapas || etapas.length === 0) {
        return (
            <p style={{ color: '#888780', fontStyle: 'italic', margin: 0 }}>
                Este trámite no tiene línea de vida (expediente cerrado).
            </p>
        );
    }

    return (
        <div style={{ paddingLeft: 4 }}>
            {etapas.map((etapa, i) => {
                const esUltima = i === etapas.length - 1;
                const completa = !!etapa.completa;
                return (
                    <div key={i} style={{ display: 'flex', gap: 12 }}>
                        {/* Columna del marcador + conector */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <i
                                className={`bi ${completa ? 'bi-check-circle-fill' : 'bi-circle'}`}
                                style={{ fontSize: 20, color: completa ? '#1D9E75' : '#B4B2A9', lineHeight: 1 }}
                            />
                            {!esUltima && (
                                <span
                                    style={{
                                        flex: 1,
                                        width: 2,
                                        minHeight: 26,
                                        background: completa ? '#1D9E75' : '#D3D1C7',
                                    }}
                                />
                            )}
                        </div>

                        {/* Contenido de la etapa */}
                        <div style={{ paddingBottom: 16 }}>
                            <div
                                style={{
                                    fontWeight: completa ? 600 : 500,
                                    color: completa ? '#26215C' : '#888780',
                                }}
                            >
                                {etapa.nombre}
                            </div>
                            {etapa.fecha && (
                                <div style={{ fontSize: 12, color: '#5F5E5A', marginTop: 2 }}>
                                    <i className="bi bi-calendar3" style={{ marginRight: 4 }} />
                                    {etapa.fecha}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default LineaDeVidaExpediente;
